module.exports = __webpack_public_path__ + "static/meta-image-f872cfb9cdd33d5538214e586bf3ea00.png";